module.exports = __webpack_public_path__ + "static/media/linkimg2.33417802.jpg";